import { render, staticRenderFns } from "./PieChartsInfeed.vue?vue&type=template&id=45c2d23e&scoped=true"
import script from "./PieChartsInfeed.vue?vue&type=script&lang=js"
export * from "./PieChartsInfeed.vue?vue&type=script&lang=js"
import style0 from "./PieChartsInfeed.vue?vue&type=style&index=0&id=45c2d23e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c2d23e",
  null
  
)

export default component.exports